import { useContext } from 'react'
import { Textfit } from "react-textfitfix"

import { PassContext } from "../../../pass-context"
import fieldFormatter from "./field-formatter"
import PopupEditor from '../../popup-editor'
import dataSelector from '../../data-selector'
import useFontsReady from './use-fonts-ready'

const Field = ({ field, idx, fontsReady }) => {

  const { model, template, variables } = useContext(PassContext)

  const foregroundColor = dataSelector({ template: model, variables, path: "foregroundColor" })
  const labelColor = dataSelector({ template: model, variables, path: "labelColor" })

  const styles = {
    label: {
      color: labelColor,
      height: 20
    },
    value: {
      color: foregroundColor,
      height: 20
    }
  }

  let labelClasses = "label overflow-hidden text-nowrap uppercase"
  let valueClasses = "value text-sm overflow-hidden items-top"

  if (field.textAlignment === "PKTextAlignmentRight") {
    labelClasses += " text-right"
    valueClasses += " text-right"
  }

  if (field.textAlignment === "PKTextAlignmentCenter") {
    labelClasses += " text-center"
    valueClasses += " text-center"
  }

  let wrapperClasses = "flex flex-col overflow-hidden w-full"

  const path = `headerFields[${idx}]`

  const resolvedField = dataSelector({ template, variables, path })
  const resolvedValue = fieldFormatter(resolvedField)

  return (
    <div className={wrapperClasses}>
      <div className={labelClasses} style={styles.label}>
        {resolvedField.label}
      </div>

      <Textfit
        key={`header-textfit-${idx}-${fontsReady ? "ready" : "pending"}`}
        mode="single"
        className={valueClasses}
        style={styles.value}
        min={8}
        max={20}
      >
        {resolvedValue}
      </Textfit>
    </div>
  )
}

const HeaderFields = ({ maxFields }) => {
  const { template } = useContext(PassContext)
  const fontsReady = useFontsReady()

  let fields = template.headerFields

  let permittedFields = fields?.slice(0, maxFields)

  return (
    <PopupEditor title="Header Fields" path="headerFields" colors={{ label: "model.labelColor", value: "model.foregroundColor" }} maxFields={maxFields}>
      <div className="flex flex-row-reverse justify-between w-1/3 gap-2 items-baseline overflow-hidden header editable">
        {permittedFields?.map((f, idx) => <Field key={f.key} field={f} idx={idx} fontsReady={fontsReady} />)}
      </div>
    </PopupEditor>
  )
}

export default HeaderFields
